import { commonFilter } from './filter';

const pageId = '250054';

export default {
  pageName: 'Realtime Opinions',
  pageId,
  pagePath: '/opinion/Overview/RealtimeOpinions',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    RO_OverviewMetrics_Tab: {
      buttonId: `${pageId}01`,
    },
    RO_OverviewMetrics_Dropdown: {
      buttonId: `${pageId}02`,
    },
    RO_Keyword_Language: {
      buttonId: `${pageId}10`,
    },
    RO_Steam_Tab: {
      buttonId: `${pageId}20`,
    },
    RO_Steam_AddedReviews_Tab: {
      buttonId: `${pageId}21`,
    },
    RO_Steam_AllReviews_Download: {
      buttonId: `${pageId}29`,
    },
    RO_Steam_Language_Metrics: {
      buttonId: `${pageId}35`,
    },
    RO_Steam_Language_Keyword: {
      buttonId: `${pageId}36`,
    },
    RO_Community_TypeTab: {
      buttonId: `${pageId}50`,
    },
    RO_Community_AccountTab: {
      buttonId: `${pageId}51`,
    },
    RO_Community_LinkTab: {
      buttonId: `${pageId}52`,
    },
    RO_Community_Title: {
      buttonId: `${pageId}53`,
    },
    RO_VideoContent_Dropdown: {
      buttonId: `${pageId}70`,
    },
    RO_StreamContent_Dropdown: {
      buttonId: `${pageId}71`,
    },
    RO_Feeds_Language: {
      buttonId: `${pageId}72`,
    },
    RO_VideoContent_Title: {
      buttonId: `${pageId}73`,
    },
    RO_StreamContent_Title: {
      buttonId: `${pageId}74`,
    },
    ...commonFilter,
  },
  card: {
    RO_OverviewMetrics: {
      line: {
        buttonId: `${pageId}03`,
      },
      stack_line: {
        buttonId: `${pageId}04`,
      },
      download: {
        buttonId: `${pageId}05`,
      },
      table: {
        buttonId: `${pageId}06`,
      },
    },
    RO_Steam_Databrain: {
      'bar-line': {
        buttonId: `${pageId}22`,
      },
      'common-th-bar': {
        buttonId: `${pageId}23`,
      },
      line: {
        buttonId: `${pageId}24`,
      },
      bar: {
        buttonId: `${pageId}25`,
      },
      stack_line: {
        buttonId: `${pageId}26`,
      },
      table: {
        buttonId: `${pageId}27`,
      },
      download: {
        buttonId: `${pageId}28`,
      },
    },
    RO_Steam_Language: {
      line: {
        buttonId: `${pageId}30`,
      },
      bar: {
        buttonId: `${pageId}31`,
      },
      pie: {
        buttonId: `${pageId}32`,
      },
      table: {
        buttonId: `${pageId}33`,
      },
      download: {
        buttonId: `${pageId}34`,
      },
    },
    KeywordCard: {
      table: {
        buttonId: `${pageId}40`,
      },
      line: {
        buttonId: `${pageId}41`,
      },
      cloud: {
        buttonId: `${pageId}42`,
      },
      download: {
        buttonId: `${pageId}43`,
      },
    },
    RO_Community_Chart: {
      pie: {
        buttonId: `${pageId}54`,
      },
      table: {
        buttonId: `${pageId}55`,
      },
      line: {
        buttonId: `${pageId}56`,
      },
      stack_line: {
        buttonId: `${pageId}57`,
      },
      'common-bar': {
        buttonId: `${pageId}58`,
      },
      bar: {
        buttonId: `${pageId}59`,
      },
      vs: {
        buttonId: `${pageId}60`,
      },
      download: {
        buttonId: `${pageId}61`,
      },
    },
  },
};
